export default __webpack_public_path__ + "static/media/flag_fi.4e0b8921.webp";